var _ellipse, _ellipse2, _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationSearch = function SvgIllustrationSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--color-disabled)",
    viewBox: "0 0 57 53",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7,
    cy: 36.9,
    fill: "var(--secondary-fill)",
    rx: 8,
    ry: 8.6,
    transform: "rotate(-90 38.7 37)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2,
    cy: 15.9,
    fill: "var(--secondary-fill)",
    rx: 8,
    ry: 8.6,
    transform: "rotate(-90 18.2 15.9)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m42.2 18.3.7-5.4 5.9.7-.7 5.3zm-33.9 22 1.3-5.2 5.7 1.1-1.3 5.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7,
    cy: 26.8,
    r: 13.5,
    fill: "inherit",
    transform: "rotate(-90 38.7 37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "m31.2 29.6.4.1.4-.1.2-.4-.2-.4-1-1a2 2 0 0 0 .4-1.3q0-1-.8-1.8-.8-.7-2-.7-1 0-1.8.7-.9.8-.8 1.8t.8 1.8q.7.6 1.9.7l1.4-.4zm-2.5-1.7q-.6 0-1-.4t-.5-1 .4-1 1-.4 1.1.4.5 1-.5 1-1 .4m-4.5 3.3q-.5 0-.9-.3L23 30v-6.6q0-.6.3-.8.4-.3.9-.4h9.6q.5 0 .8.4.4.2.4.8V30q0 .5-.4.8-.3.3-.8.3z"
  })));
};
export default SvgIllustrationSearch;